import React from 'react'
import { useParams } from "react-router-dom";
import Main from '../main/Main';
import Landing from '../landing/Landing';

const Entry = () => {

    const { username } = useParams();
    console.log("the username: " + username + "/")
  return (
    <div>
      {username ? (
        <Main usernameL={username} />
      ) : (
        <Landing />
      )}
    </div>
  )
}

export default Entry